export const removeDuplicates = (arr = [], prop = 'id') => {
  return arr.filter((v1, i, a) => !v1[prop] || a.findIndex((v2) => (v2[prop] && v1[prop] && (v2[prop] === v1[prop]))) === i);
};
